import { Trans } from "react-i18next";

import type { NotificationContentProps } from "../../types";

export default function AiChallengeFormatContent({
  events = [],
  ownerIdea,
  ownerChallenge,
  ownerGroup,
  context,
  status,
}: NotificationContentProps) {
  return (
    <Trans
      i18nKey={
        status === "success"
          ? "notifications.aiChallengeFormatSuccess"
          : status === "pending"
            ? "notifications.aiChallengeFormat"
            : "notifications.aiChallengeFormatFailed"
      }
      values={{ challenge: ownerChallenge?.name || "Deleted" }}
    />
  );
}
